import { Link } from "@remix-run/react";
import { ShoppingCart } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui/button";

export function EmptyCartState() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-12 text-center">
      <ShoppingCart className="size-16 text-neutral-300" />
      <div>
        <h3 className="text-lg font-medium text-neutral-700">{t("cart.sidebar.empty")}</h3>
        {/* Este slot mostraba `continueShopping`, la MISMA cadena que el botón de abajo:
            quedaba "Seguir Comprando" en gris justo encima de "Seguir Comprando" en rojo,
            como si fueran dos acciones. El subtítulo ahora dice algo propio. */}
        {/* `neutral-500` (#999) da 2.78:1 sobre el fondo claro, debajo del 4.5:1 que pide
            WCAG para texto normal. `neutral-800` da 5.7:1 en claro y aclara en oscuro. */}
        <p className="mt-1 text-sm text-neutral-800">{t("cart.page.emptyHint")}</p>
      </div>
      <Button variant="brand" asChild>
        <Link to="/courses">{t("cart.page.continueShopping")}</Link>
      </Button>
    </div>
  );
}
